import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "17",
  fill: "none",
  viewBox: "0 0 17 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3.833 15.833 4.673 14l1.827-.833-1.827-.84-.84-1.827L3 12.327l-1.833.84L3 14m7.5-.167 1.667-3.666L15.833 8.5l-3.666-1.667L10.5 3.167 8.833 6.833 5.167 8.5l3.666 1.667m-5-3.667.84-1.827 1.827-.84L4.673 3l-.84-1.833L3 3l-1.833.833L3 4.673"
    }, null, -1)
  ]))]))
}
export default { render: render }